import React from 'react';
import PropTypes from 'prop-types';

const DividerWithMessage = ({ message }) => {
  return (
    <div className="tw-flex">
      <hr className="tw-border-gray-400" />
      <span className="tw-body-xs-bold tw-relative tw-bottom-2 tw-mx-2 tw-text-gray-700">
        {message}
      </span>
      <hr className="tw-border-gray-400" />
    </div>
  );
};

DividerWithMessage.propTypes = {
  message: PropTypes.string.isRequired,
};

export default DividerWithMessage;
